import React from 'react';
/* --- import Components ----*/
import { ButtonSocialMedia } from '../Founders/elements';
import { SentenceSmall } from '../Typography';
/* --- import Styles and Images ----*/
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';
import { Instagram, Linkedin, Youtube } from '../Icons/Social Media';

const SocialMedia = ({ origin, modal }) => {
  return (
    <div
      css={{
        [mediaQueries.phoneOnly]: {
          marginBottom:
            origin === 'applyForm' && !modal ? 50 : origin === 'applyForm' && modal ? -50 : 'none',
        },
        [mediaQueries.tabletPortraitUp]: {
          marginBottom:
            origin === 'applyForm' && !modal ? 150 : origin === 'applyForm' && modal ? 50 : 'none',
        },
        [mediaQueries.tabletLandscapeUp]: {
          marginBottom:
            origin === 'applyForm' && !modal ? 200 : origin === 'applyForm' && modal ? 50 : 'none',
        },
      }}
    >
      <section>
        <a
          css={{ textDecoration: 'none', color: colors.purpleVeryDark }}
          href="http://lereacteur.io"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          <SentenceSmall css={{ marginBottom: 5 }}> www.lereacteur.io</SentenceSmall>
        </a>
      </section>
      <section css={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
        <ButtonSocialMedia css={{ marginRight: 0 }}>
          <a
            href="https://www.linkedin.com/school/le-reacteur/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="linkedin"
          >
            <Linkedin />
          </a>
        </ButtonSocialMedia>
        <ButtonSocialMedia css={{ marginRight: 0 }}>
          <a
            href="https://www.instagram.com/lereacteur.io/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="instagram"
          >
            <Instagram />
          </a>
        </ButtonSocialMedia>
        <ButtonSocialMedia css={{ marginRight: 0 }}>
          <a
            href="https://www.youtube.com/channel/UCZiSHyumY80PJWHUr9jiDvQ"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="youtube"
          >
            <Youtube />
          </a>
        </ButtonSocialMedia>
      </section>
    </div>
  );
};

export default SocialMedia;
